import { Avatar, Menu, Dropdown, Button, Drawer } from 'antd';
import { DownOutlined, LockOutlined, LogoutOutlined, TranslationOutlined, UserOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useUser } from "../../../context/UserContext";
import { useEffect, useState } from "react";
import ApiService from "../../../service/ApiService";
import { LocalStorageService } from "../../../service/LocalStorageService";
import ChangePasswordModal from "./ChangePasswordModal";

const { SubMenu } = Menu;

/**
 * Header'daki kullanıcı menüsü.
 *
 * Masaüstü: baş harfli AMBER avatar + ad + ok (hap formunda, ince çerçeveli).
 * Avatar'ın amber olması bilinçli: kullanıcı kimliği, header'daki marka imzasının üçüncü dokunuşu.
 * Renkler --header-fg üzerinden gelir; header rengi kiracıya göre değiştiği için sabit beyaz kullanılamaz.
 *
 * Mobil: aynı avatar, kare eylem butonunda; menü sağdan çekmecede (hamburger menüsüyle aynı ölçek).
 */
export default function ProfileDropdown({ isMobile }) {
    const { t } = useTranslation();
    const { signOut, setUser, user } = useUser();
    const [visible, setVisible] = useState(false)
    const [passwordOpen, setPasswordOpen] = useState(false)

    // "Ahmet Yılmaz" → "AY" (tek isimse tek harf)
    const initials = (user?.name || '')
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map(part => part[0])
        .join('')
        .toUpperCase();

    const onClick = (item) => {
        if (item.key === 'logout') {
            signOut()
        }
        else if (item.key === 'password') {
            setPasswordOpen(true)
        }
        else if (['en', 'tr'].includes(item.key)) {
            LocalStorageService.setLanguage(item.key)
            window.location.reload()
        }
    }

    const getUser = async () => {
        const response = await ApiService.User.Information();
        if (response.success) {
            setUser(response.data)
        }
    }

    useEffect(() => {
        ApiService.setLogout(signOut)
    }, [])

    useEffect(() => {
        getUser()
    }, [])

    const menu = (
        <Menu onClick={onClick}>
            <SubMenu icon={<TranslationOutlined />} key={'languages'} title={t('Language')}>
                <Menu.Item key="en">English</Menu.Item>
                <Menu.Item key="tr">Türkçe</Menu.Item>
            </SubMenu>
            <Menu.Item key="password" icon={<LockOutlined />}>
                {t('Change Password')}
            </Menu.Item>
            <Menu.Item key="logout" icon={<LogoutOutlined />} danger>
                {t('Logout')}
            </Menu.Item>
        </Menu>
    );

    // Parola değişince sunucu bu kullanıcının tüm token'larını eler — bu oturum dahil. Kendimiz
    // çıkış yapmazsak kullanıcı bir sonraki istekte sebepsiz bir 401 yer.
    const passwordModal = (
        <ChangePasswordModal
            open={passwordOpen}
            onClose={() => setPasswordOpen(false)}
            onChanged={signOut}
        />
    );

    if (isMobile) {
        return (
            <>
                <Button
                    type="text"
                    className="header-action"
                    aria-label={user?.name || t('Profile')}
                    onClick={() => setVisible(true)}
                    icon={
                        <Avatar size={28} className="header-user-avatar">
                            {initials || <UserOutlined />}
                        </Avatar>
                    }
                />
                <Drawer
                    title={user?.name || t('Profile')}
                    placement="right"
                    closable={true}
                    onClose={() => setVisible(false)}
                    open={visible}
                    styles={{ body: { padding: 0 } }}
                    width="min(86vw, 320px)"
                    className="mobile-nav-drawer nav-drawer"
                >
                    {/* Hamburger menüsüyle aynı tap-friendly ölçek (.mobile-nav-drawer, layout.css) */}
                    <Menu
                        onClick={(item) => { onClick(item); setVisible(false); }}
                        mode="inline"
                        /* defaultOpenKeys SubMenu'nün değil Menu'nün prop'u — SubMenu'de duruyordu,
                           yani hiç okunmuyordu ve dil listesi kapalı açılıyordu. */
                        defaultOpenKeys={['languages']}
                        style={{ border: 'none' }}
                    >
                        <SubMenu icon={<TranslationOutlined />} key={'languages'} title={t('Language')}>
                            <Menu.Item key="en">English</Menu.Item>
                            <Menu.Item key="tr">Türkçe</Menu.Item>
                        </SubMenu>
                        <Menu.Item key="password" icon={<LockOutlined />}>
                            {t('Change Password')}
                        </Menu.Item>
                        <Menu.Item key="logout" icon={<LogoutOutlined />} danger>
                            {t('Logout')}
                        </Menu.Item>
                    </Menu>
                </Drawer>
                {passwordModal}
            </>
        )
    }

    return (
        <>
            <Dropdown overlay={menu} placement="bottomRight" trigger={['click']}>
                <Button type="text" className="header-user">
                    <Avatar size={28} className="header-user-avatar">
                        {initials || <UserOutlined />}
                    </Avatar>
                    <span className="header-user-name">{user?.name}</span>
                    <DownOutlined className="header-user-caret" />
                </Button>
            </Dropdown>
            {passwordModal}
        </>
    )
}
